import { Component } from '@angular/core';

@Component({
  selector: 'landing-inversores-footer',
  templateUrl: './landing-footer.component.html',
  styleUrls: ['./landing-footer.component.scss'],
})
export class LandingFooterComponent {
  readonly currentYear = new Date().getFullYear();
}
